import {SellerError} from './SellerError.js'

export class InvalidAppointmentRequestSellerError extends SellerError {}
